import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Typography,
  IconButton,
  Chip,
} from '@mui/material';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import { Add, Edit, Delete } from '@mui/icons-material';
import { useSerieStore } from './store';
import { SerieEditDialog } from './components/SerieEditDialog';
import type { SerieListItem } from './types/serie';

export const SeriesPage: React.FC = () => {
  const { series, loading, fetchSeries, deleteSerie } = useSerieStore();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editItem, setEditItem] = useState<SerieListItem | null>(null);

  useEffect(() => {
    fetchSeries();
  }, []);

  const handleNew = () => {
    setEditItem(null);
    setDialogOpen(true);
  };

  const handleEdit = (item: SerieListItem) => {
    setEditItem(item);
    setDialogOpen(true);
  };

  const handleDelete = async (item: SerieListItem) => {
    if (window.confirm(`Eliminar serie ${item.serie}?`)) {
      await deleteSerie(item.idTalonario);
    }
  };

  const columns: GridColDef[] = [
    {
      field: 'comprobante',
      headerName: 'Tipo Comprobante',
      flex: 1,
      minWidth: 180,
    },
    {
      field: 'serie',
      headerName: 'Serie',
      width: 120,
      renderCell: (params) => (
        <Chip label={params.value} color="primary" size="small" variant="outlined" />
      ),
    },
    {
      field: 'proximoNumero',
      headerName: 'Proximo Nro.',
      width: 130,
      type: 'number',
    },
    {
      field: 'esPrincipal',
      headerName: 'Principal',
      width: 100,
      renderCell: (params) => params.value ? 'Si' : 'No',
    },
    {
      field: 'acciones',
      headerName: 'Acciones',
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton size="small" onClick={() => handleEdit(params.row)}>
            <Edit fontSize="small" />
          </IconButton>
          <IconButton size="small" color="error" onClick={() => handleDelete(params.row)}>
            <Delete fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h5" fontWeight="bold">Series / Talonarios</Typography>
          <Typography variant="body2" color="text.secondary">
            Administra las series de comprobantes de venta
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<Add />} onClick={handleNew}>
          Nueva Serie
        </Button>
      </Box>

      <DataGrid
        rows={series}
        columns={columns}
        getRowId={(row) => row.idTalonarioComprobante}
        loading={loading}
        autoHeight
        pageSizeOptions={[10, 25]}
        initialState={{
          pagination: { paginationModel: { pageSize: 10 } },
        }}
        disableRowSelectionOnClick
      />

      <SerieEditDialog
        open={dialogOpen}
        editItem={editItem}
        onClose={() => setDialogOpen(false)}
      />
    </Box>
  );
};

export default SeriesPage;
